var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6735 11.9923V14.1062C15.6743 14.3025 15.633 14.4968 15.5525 14.6765C15.4721 14.8564 15.354 15.0177 15.206 15.1505C15.058 15.2831 14.8832 15.3841 14.6929 15.4471C14.5026 15.5099 14.3009 15.5332 14.1008 15.5156C11.8809 15.28 9.74857 14.539 7.8751 13.3523C6.13205 12.2704 4.65423 10.827 3.54665 9.12437C2.32744 7.28606 1.56873 5.19308 1.33199 3.01494C1.31391 2.8201 1.33766 2.62372 1.40158 2.43829C1.46549 2.25285 1.5683 2.08252 1.70331 1.93802C1.83839 1.79345 2.00275 1.67802 2.18597 1.59896C2.36919 1.5199 2.56726 1.47904 2.76756 1.47883H4.93179C5.28187 1.47546 5.62127 1.59658 5.88671 1.81957C6.15214 2.04257 6.32553 2.3522 6.37453 2.69084C6.46593 3.36734 6.6353 4.03162 6.87958 4.67091C6.97657 4.92312 6.99759 5.19723 6.94005 5.46074C6.88252 5.72424 6.74887 5.96613 6.55488 6.15774L5.6387 7.05267C6.66565 8.81676 8.16105 10.2775 9.96708 11.2807L10.8833 10.3856C11.0795 10.1962 11.3272 10.0657 11.5969 10.0094C11.8667 9.95323 12.1473 9.9738 12.4054 10.0685C13.06 10.3071 13.7401 10.4726 14.4327 10.5618C14.783 10.6102 15.1031 10.7825 15.3319 11.0462C15.5607 11.31 15.6823 11.6468 15.6735 11.9923Z",
    stroke: "#0E1318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.9da6d878f62089babf2f256ff3121ef8.svg";
export { ForwardRef as ReactComponent };